import { useI18n } from '@change-corgi/core/react/i18n';

import { usePetitionEditPageState } from 'src/app/pages/petitionEditV2/pageContext';

type UseTitleDataReturn = ModelHookResult<
	{
		label: string;
		value: string | undefined;
		error: string | null;
	},
	{ handleChange: (value: string) => void }
>;

export function useTitleData(): UseTitleDataReturn {
	const [state, mutations] = usePetitionEditPageState();
	const { translate } = useI18n();

	const handleChange = (value: string) => {
		if (state.formState.ask.error) {
			mutations.resetFieldError('ask');
		}
		mutations.setTitle(value);
	};

	return {
		data: {
			label: translate('corgi.petition.edit.petition_content.ask.title'),
			value: state.formState.ask.value,
			error: state.formState.ask.error !== null ? translate(state.formState.ask.error) : null,
		},
		actions: {
			handleChange,
		},
	};
}
